<script setup lang="ts">
import ShareLinkPanel from './ShareLinkPanel.vue'
import { shareSavedStrategy, unshareSavedStrategy } from './api'
import { LIBRARY_EVENT_NAMES } from './library_event_names'
import { useShareLink } from './useShareLink'
import { CONTENT_TYPES } from '@/util/access_visibility'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin.ts'

const props = defineProps({
  uuid: {
    type: String,
    required: true
  },
  shareState: {
    type: Boolean,
    required: true
  },
  shareLinkState: {
    type: String,
    default: ''
  }
})

const analytics = getAnalyticsTracker()
const { sharing, shared, shareLink, shareContent, unshareContent } = useShareLink(
  () => ({ uuid: props.uuid, shareState: props.shareState, shareLinkState: props.shareLinkState }),
  { share: shareSavedStrategy, unshare: unshareSavedStrategy, contentLabel: 'strategy' }
)

async function shareStrategy() {
  analytics.sendEvent(LIBRARY_EVENT_NAMES.SHARE_STRATEGY.CLICKED_CREATE_SHARE_LINK)
  if (await shareContent()) {
    analytics.sendEvent(LIBRARY_EVENT_NAMES.SHARE_STRATEGY.SHARED)
  }
}

function recordLinkCopied() {
  analytics.sendEvent(LIBRARY_EVENT_NAMES.COPIED_SHARE_LINK, {
    share_content_type: CONTENT_TYPES.SAVED_STRATEGY
  })
}
</script>

<template>
  <ShareLinkPanel
    :is-shared="shared"
    :share-link="shareLink"
    :is-sharing="sharing"
    link-label="Link to share strategy"
    show-copied-check
    @share="shareStrategy"
    @unshare="unshareContent"
    @copied="recordLinkCopied"
  />
</template>
